import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-portrait-screen",
  "use": "icon-portrait-screen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-portrait-screen\"><path d=\"M959.5 512c0-247.1-200.4-447.5-447.5-447.5S64.5 264.8 64.5 512 264.9 959.5 512 959.5 959.5 759.1 959.5 512z m-632 255.5v-511h369v510.9l-369 0.1z\" fill=\"#000000\" p-id=\"3457\" /><path d=\"M400.8 331.6h222.4v360.8H400.8z\" fill=\"#000000\" p-id=\"3458\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol